import { render, staticRenderFns } from "./ContractReleasedPo.vue?vue&type=template&id=6d2d915b&scoped=true&"
import script from "./ContractReleasedPo.vue?vue&type=script&lang=js&"
export * from "./ContractReleasedPo.vue?vue&type=script&lang=js&"
import style0 from "./ContractReleasedPo.vue?vue&type=style&index=0&id=6d2d915b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2d915b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d2d915b')) {
      api.createRecord('6d2d915b', component.options)
    } else {
      api.reload('6d2d915b', component.options)
    }
    module.hot.accept("./ContractReleasedPo.vue?vue&type=template&id=6d2d915b&scoped=true&", function () {
      api.rerender('6d2d915b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/submission-request/ContractReleasedPo.vue"
export default component.exports